
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/relatorios-financeiros",
      function () {
        return require("private-next-pages/relatorios-financeiros/index.js");
      }
    ]);
  